export const webClientId = '887194964445-vga7o4h0gn5dqdg113ai68e3d9c2eekr.apps.googleusercontent.com'